import React from 'react';
import SiteFooter from '../includes/SiteFooter';

class PagePreferencesOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div id="site-main" className="page bow" role="main" tabIndex="-1">
          <div className="container" id="site-main-container">
            <div className="row">
              <div className="col-md1-24">
                <div className="c-step-header">
                  <p className="c-step-header__crumbs">
                    <a
                      className="c-step-header__link"
                      href=""
                      onClick={this.props.closed}
                    >
                      <span className="icon icon-page-back c-step-header__linkicon" />
                      <span className="c-step-header__linktext">Back</span>
                    </a>
                  </p>
                  <h2
                    className="c-step-header__title"
                    id="page-preferences-order-heading"
                  >
                    Change account order
                  </h2>
                </div>

                <p>
                  Here's the order your accounts will be shown in when you're on
                  B on Web.
                </p>

                <p>
                  <strong>
                    Use the arrow buttons to move an account up or down the
                    display order
                  </strong>
                  .
                </p>

                <ol
                  className="u-no-padding"
                  role="list"
                  aria-labelledby="page-preferences-order-heading"
                >
                  <li
                    role="listitem"
                    className="c-account c-account--preferences l-preferences"
                  >
                    <div className="l-preferences__account">
                      <h3 className="c-account__name">Savings</h3>

                      <dl className="c-account__defs">
                        <dt className="c-account__term">Sortcode</dt>
                        <dd className="c-account__sortno">23-44-61</dd>
                        <dt className="c-account__term">Account number</dt>
                        <dd className="c-account__accountno">413423466</dd>
                        <dt className="c-account__term">Balance</dt>
                        <dd className="c-account__balance">&pound;1,200.50</dd>
                      </dl>
                    </div>
                    <div className="l-preferences__preferences">
                      <div className="c-account__controls">
                        <span className="u-visually-hidden off-screen">
                          Change order{' '}
                        </span>
                        <button
                          disabled="disabled"
                          className="c-account__controls-top c-btn c-btn--secondary c-btn--icon-only"
                        >
                          <span className="icon icon-reorder-up" />
                          <span className="u-visually-hidden off-screen">
                            Move Up
                          </span>
                        </button>

                        <button className="c-account__controls-bottom c-btn c-btn--secondary c-btn--icon-only">
                          <span className="icon icon-reorder-down" />
                          <span className="u-visually-hidden off-screen">
                            Move Down
                          </span>
                        </button>
                      </div>
                    </div>
                  </li>

                  <li
                    role="listitem"
                    className="c-account c-account--preferences l-preferences"
                  >
                    <div className="l-preferences__account">
                      <h3 className="c-account__name">Savings</h3>

                      <dl className="c-account__defs">
                        <dt className="c-account__term">Sortcode</dt>
                        <dd className="c-account__sortno">23-44-61</dd>
                        <dt className="c-account__term">Account number</dt>
                        <dd className="c-account__accountno">413423466</dd>
                        <dt className="c-account__term">Balance</dt>
                        <dd className="c-account__balance">&pound;1,200.50</dd>
                      </dl>
                    </div>
                    <div className="l-preferences__preferences">
                      <div className="c-account__controls">
                        <span className="u-visually-hidden off-screen">
                          Change order{' '}
                        </span>
                        <button className="c-account__controls-top c-btn c-btn--secondary c-btn--icon-only">
                          <span className="icon icon-reorder-up" />
                          <span className="u-visually-hidden off-screen">
                            Move Up
                          </span>
                        </button>

                        <button className="c-account__controls-bottom c-btn c-btn--secondary c-btn--icon-only">
                          <span className="icon icon-reorder-down" />
                          <span className="u-visually-hidden off-screen">
                            Move Down
                          </span>
                        </button>
                      </div>
                    </div>
                  </li>

                  <li
                    role="listitem"
                    className="c-account c-account--preferences l-preferences"
                  >
                    <div className="l-preferences__account">
                      <h3 className="c-account__name">Savings</h3>

                      <dl className="c-account__defs">
                        <dt className="c-account__term">Sortcode</dt>
                        <dd className="c-account__sortno">23-44-61</dd>
                        <dt className="c-account__term">Account number</dt>
                        <dd className="c-account__accountno">413423466</dd>
                        <dt className="c-account__term">Balance</dt>
                        <dd className="c-account__balance">&pound;1,200.50</dd>
                      </dl>
                    </div>
                    <div className="l-preferences__preferences">
                      <div className="c-account__controls">
                        <span className="u-visually-hidden off-screen">
                          Change order{' '}
                        </span>
                        <button className="c-account__controls-top c-btn c-btn--secondary c-btn--icon-only">
                          <span className="icon icon-reorder-up" />
                          <span className="u-visually-hidden off-screen">
                            Move Up
                          </span>
                        </button>

                        <button
                          disabled="disabled"
                          className="c-account__controls-bottom c-btn c-btn--secondary c-btn--icon-only"
                        >
                          <span className="icon icon-reorder-down" />
                          <span className="u-visually-hidden off-screen">
                            Move Down
                          </span>
                        </button>
                      </div>
                    </div>
                  </li>
                </ol>

                <div className="form-actions">
                  <a href="" className="c-btn c-btn--secondary">
                    Back
                  </a>
                  <button
                    type="submit"
                    href=""
                    className="c-btn c-btn--default"
                  >
                    Confirm changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <SiteFooter />
      </div>
    );
  }
}

export default PagePreferencesOrder;
